import {MutationTree} from 'vuex'
import {initialState, LobbyDataState} from '@/store/modules/lobby'
import {LobbyDataResponse} from "@/models/LobbyDataResponse.model";

export interface LobbyDataPayload {
    lobbyData: LobbyDataResponse
    expirationDate: number
}

export const mutations: MutationTree<LobbyDataState> = {

    setLobbyData: (state, {lobbyData, expirationDate}: LobbyDataPayload) => {
        state.totalsSection = lobbyData.totalsSection
        state.distributionChartSection = lobbyData.distributionChartSection
        state.loginAuditChartSection = lobbyData.loginAuditChartSection
        state.mngCompanyMessageSection = lobbyData.mngCompanyMessageSection
        state.etlJobsSection = lobbyData.etlJobsSection
        state.expirationDate = expirationDate
        state.isEmpty = false
    },

    resetState: (state) => {
        state = Object.assign(state, initialState())
    }
}